import { useState, useRef, useEffect } from 'react';
import PropTypes from 'prop-types';

import Container from '../../../Core/Container';

import {
  GalleryWrapper,
  AnimationWrapper,
  ImgWrapper,
  GalleryImage,
  PausePlayBtn,
} from './styles';

// Images array needs to be returned twice within the carousel otherwise a large gap will be shown at the end of the cycle of a single array return. There also needs to be a even amount of images being pulled form the CMS otherwise the background colors will be out of order and the ticker will appear to be broken.
const Gallery = ({ images, uId }) => {
  return (
    images &&
    images.map(image => {
      return (
        <ImgWrapper key={`${image.id}-${uId}`}>
          <GalleryImage
            src={image}
            alt={image.altText || ''}
            objectFit="cover"
          />
        </ImgWrapper>
      );
    })
  );
};

const TickerGallery = ({ data }) => {
  // * Null check for dataItem
  if (!data) return null;

  // * Destructure dataItem values
  const { imagesDam } = data;

  const [sliding, setSliding] = useState(true);

  // * reference to the animation
  const animation = useRef(null);

  useEffect(() => {
    // * make sure the component has been mounted first
    if (animation.current) {
      // * checks if the current style is set to running and pauses otherwise sets value to running
      animation.current.style.animationPlayState = !sliding
        ? 'paused'
        : 'running';
    }
  }, [sliding]);

  return (
    <Container className="test">
      <GalleryWrapper>
        <PausePlayBtn sliding={sliding} onClick={() => setSliding(!sliding)}>
          {sliding ? (
            <>
              <svg
                width="13"
                height="15"
                viewBox="0 0 13 15"
                fill="currentColor"
                xmlns="http://www.w3.org/2000/svg"
              >
                <title>Pause</title>
                <rect width="4.33333" height="15" fill="currentColor" />
                <rect
                  x="8.66602"
                  width="4.33333"
                  height="15"
                  fill="currentColor"
                />
              </svg>
              <span>Pause</span>
            </>
          ) : (
            <>
              <svg
                width="13"
                height="15"
                viewBox="0 0 13 15"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <title>Play</title>
                <path
                  d="M13 7.5L0.249999 14.8612L0.25 0.138783L13 7.5Z"
                  fill="currentColor"
                />
              </svg>
              <span>Play</span>
            </>
          )}
        </PausePlayBtn>
        <AnimationWrapper ref={animation} images={imagesDam.length}>
          <Gallery images={imagesDam} uId="group-1" />
          <Gallery images={imagesDam} uId="group-2" />
        </AnimationWrapper>
      </GalleryWrapper>
    </Container>
  );
};

TickerGallery.propTypes = {
  data: PropTypes.shape().isRequired,
};

export default TickerGallery;
